import { render, staticRenderFns } from "./insUserRole.vue?vue&type=template&id=2c4e6a6f&"
import script from "./insUserRole.vue?vue&type=script&lang=js&"
export * from "./insUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports